import { useNavigate } from 'react-router-dom';
import { TFormData } from '../formSchema';
import { useAppDispatch } from '../../../../../storeHook';
import { showAlert } from '../../../../../services/alert';
import { useUpdateSkuDiscountDetailsMutation } from '../../../../../services/discounts';
import { TSkuDiscount } from '../../../../../utils/types';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

export const useOnSubmitDiscountData = (
  fetchedData: TSkuDiscount | undefined
) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const [updateSkuDetails] =
    useUpdateSkuDiscountDetailsMutation();

  const getFormattedUtcDate = (date: Date) =>
    dayjs(date).utc().format('YYYY-MM-DDTHH:mm:ssZ');

  const getFormattedDateStr = (date: Date) =>
    dayjs(date).format('DD MMM YYYY HH:mm');

  const onSubmitData = (values: TFormData) => {
    // this.spinner.showSpinner.emit(true);
    fetchedData &&
      updateSkuDetails({
        ...fetchedData,
        discountValue: values.discountValue,
        periodFrom: getFormattedUtcDate(
          values.startDateAndTime
        ),
        periodFromStr: getFormattedDateStr(
          values.startDateAndTime
        ),
        periodTo: getFormattedUtcDate(
          values.endDateAndTime
        ),
        periodToStr: getFormattedDateStr(
          values.endDateAndTime
        ),
      })
        .unwrap()
        .then(() => {
          dispatch(
            showAlert({
              content:
                'discount details updated successfully',
            })
          );
          navigate('/discounts#sku-discounts');
        })
        .catch((err) => {
          console.log(
            'add discounts err',
            err?.data?.title
          );
          // this.utility.handleError(err)
        });
  };

  return onSubmitData;
};
